import React from 'react';
import './HomeBooking.css';

import { BookingForm } from '../../../components';


const HomeBooking = () => (

  <section className="home-booking linear-bg">
    <div className="box-container">
      <div className="content">
        <BookingForm formType="home-booking" />
      </div>
    </div>
  </section>

);

export default HomeBooking;